// FormsLayout — shared chrome for the Forms area: the collapsible left sidebar
// plus the routed page content. Wraps the browse/manage routes (/forms,
// /forms/list, /forms/classification-sets, records). The full-bleed builder
// editor and import workspace stay outside this layout.

import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { NAVBAR_HEIGHT } from "../../pages/Map";
import FormsSidebar from "./FormsSidebar";

const FormsLayout: React.FC = () => (
  <Box sx={{ height: `calc(100vh - ${NAVBAR_HEIGHT})`, width: "100%", display: "flex", overflow: "hidden" }}>
    <FormsSidebar />
    <Box sx={{ flex: 1, minWidth: 0, height: "100%", overflow: "hidden" }}>
      <Outlet />
    </Box>
  </Box>
);

export default FormsLayout;
